import { queueTrackingEvent } from '@library/tracking-integration'
import type { DeliveryEligibility } from '@library/delivery-timing'

export enum TrackingActions {
  CLICK_GET_STARTED = 'click_get_started',
  CLICK_GET_STARTED_STICKY_CTA = 'click_get_started_sticky_cta',
  NDD_BANNER = 'ndd_banner',
  NDD_CTA = 'ndd_cta',
  COMPREHENSION_GAP_BANNER_CTA = 'comprehension_gap_banner_cta',
}

export enum Sections {
  HERO = 'hero',
  STICKY_CTA = 'sticky_cta',
}

type CTAClickTrackingData = {
  action: TrackingActions
  properties: {
    section: Sections
  }
}

type NDDBannerTrackingData = {
  action: TrackingActions.NDD_BANNER
  properties: {
    offer: DeliveryEligibility | null
  }
}

type NDDCTATrackingData = {
  action: TrackingActions.NDD_CTA
  properties: {
    offer: DeliveryEligibility | null
  }
}

export function trackCTAClick(action: TrackingActions, homepageSection: Sections) {
  queueTrackingEvent<CTAClickTrackingData>({
    action,
    properties: {
      section: homepageSection,
    },
  })
}

export function trackNDDBannerImpression(offerType: DeliveryEligibility | null) {
  queueTrackingEvent<NDDBannerTrackingData>({
    action: TrackingActions.NDD_BANNER,
    properties: {
      offer: offerType,
    },
  })
}

export function trackNDDCTAClick(offerType: DeliveryEligibility | null) {
  queueTrackingEvent<NDDCTATrackingData>({
    action: TrackingActions.NDD_CTA,
    properties: {
      offer: offerType,
    },
  })
}
